import { box, container, pageSubtitle } from '@/ui/components';
import { h, defineComponent } from 'vue';
import { loginByToken, hasSsoEnabled, verifyOtp } from '@/ui/auth/auth';
import { locales, t } from '@/ui/i18n/i18n';
import { useSetLocale, useTask } from '@/ui/concerns';
import { StatusCodes } from 'http-status-codes';
import { AuthIllustration } from '@/ui/components/auth/AuthIllustrations';
import { v4 as uuidv4 } from 'uuid';
import * as qs from '@/ui/queryState';
import { pushRoute } from '@/ui/helpers';
import { ApiError } from '@/services/api';

interface LocalePageProps {
  locale?: locales;
}

const redirectToLoginPageWithError = (error: ApiError) => {
  if ([StatusCodes.UNAUTHORIZED, StatusCodes.UNPROCESSABLE_ENTITY, StatusCodes.BAD_REQUEST].includes(error.code)) {
    pushRoute({ name: 'ssoLogin', query: { error: error.message } });
  }
};

export const SsoVerifyPage = defineComponent<LocalePageProps>({
  name: 'SsoVerifyPage',
  props: ['locale'],
  setup(props) {
    useSetLocale(props.locale);

    const token = qs.string('token', '', false);

    useTask(
      () => verifyOtp(token.value),
      data => {
        useTask(
          loginByToken(data.token),
          () => {
            pushRoute({ name: 'home' });
          },
          uuidv4(),
          error => {
            redirectToLoginPageWithError(error);
          },
        ).run();
      },
      uuidv4(),
      error => {
        redirectToLoginPageWithError(error);
      },
    ).run(token);

    return function render() {
      if (!hasSsoEnabled.value) {
        pushRoute({ name: 'login' });
      }

      return container(
        [
          box([
            pageSubtitle(t('auth.sso-verifying-your-data')),
            h(AuthIllustration),
          ]),
        ],
        'small',
        'px-8 pt-10',
      );
    };
  },
});
